import { render, staticRenderFns } from "./SpeakersSettings.vue?vue&type=template&id=4609c406&scoped=true&lang=pug&"
import script from "./SpeakersSettings.vue?vue&type=script&lang=js&"
export * from "./SpeakersSettings.vue?vue&type=script&lang=js&"
import style0 from "./SpeakersSettings.vue?vue&type=style&index=0&id=4609c406&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4609c406",
  null
  
)

export default component.exports